import type { LanguageCode } from '@sparted/shared-library/business/types';
import { DeepPartial } from 'ts-essentials';

import { fetchFactory } from 'Libs/http/utils';
import { createAsyncAction } from 'Libs/redux/utils';

import type { ContentEntity, ContentFromApi } from '../content.types';
import { updateContent as updateContentHook } from './content.hook';

type fetchContentByIdArgs = {
  contentId: number;
};
export const fetchContentById = createAsyncAction<ContentFromApi, fetchContentByIdArgs>(
  'contents/fetchById',
  ({ contentId }) => {
    const { fetchFn } = fetchFactory<ContentFromApi>({
      route: `/api/contents/${contentId}`,
      method: 'GET',
    });
    return fetchFn();
  },
);

type UpdateContentArgs = {
  contentId: number;
  content: DeepPartial<ContentEntity>;
};
export const updateContent = createAsyncAction<ContentFromApi, UpdateContentArgs>('contents/update', async (args) => {
  return updateContentHook(args.contentId, args.content);
});

type ManageContentTranslationValidationArgs = {
  contentId: number;
  languageCode: LanguageCode;
  validate: boolean;
};
export const manageContentTranslationValidation = createAsyncAction<
  ContentFromApi,
  ManageContentTranslationValidationArgs
>('contents/validate-translation', ({ contentId, languageCode, validate }) => {
  const { fetchFn } = fetchFactory<ContentFromApi>({
    route: `/api/contents/${contentId}/translation/status`,
    method: 'PATCH',
    payload: {
      languageCode,
      validate,
    },
  });
  return fetchFn();
});

type ArchiveContentArgs = {
  contentId: number;
};
export const archiveContent = createAsyncAction<ContentFromApi, ArchiveContentArgs>(
  'contents/archive',
  ({ contentId }) => {
    const { fetchFn } = fetchFactory<ContentFromApi>({
      route: `/api/contents/${contentId}/archive`,
      method: 'PUT',
    });
    return fetchFn();
  },
);

export const unarchiveContent = createAsyncAction<ContentFromApi, ArchiveContentArgs>(
  'contents/unarchive',
  ({ contentId }) => {
    const { fetchFn } = fetchFactory<ContentFromApi>({
      route: `/api/contents/${contentId}/unarchive`,
      method: 'PUT',
    });
    return fetchFn();
  },
);
